module.exports = __webpack_public_path__ + "static/media/avatar.a45ac0e3.png";